import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cgu',
  imports: [RouterModule],
  templateUrl: './cgu.component.html',
  styleUrl: './cgu.component.css',
})
export class CguComponent {}